import { Component, Input, Renderer2, ViewChild } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../../../../../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { InputDatepickerRendererComponent } from '../../../../../../ag-grid/input-datepicker-renderer/input-datepicker-renderer.component';

@Component({
  selector: 'app-aml-details-slider',
  templateUrl: './aml-details-slider.component.html',
  styleUrls: ['./aml-details-slider.component.scss']
})
export class AmlDetailsSliderComponent extends CommonService {
  amlDetailsModel: any = {};
  @ViewChild("AMLDetailsForm") AMLDetailsForm!: NgForm;
  pep : typeof PEP = PEP;
  dualNationality : typeof DualNationality = DualNationality;
  residentialStatus : typeof ResidentialStatus = ResidentialStatus;
  @Input() data                 : any  = {};
  @ViewChild('idIssuedDateComp') idIssuedDateComponent: InputDatepickerRendererComponent;
  @ViewChild('idExpiryDateComp') idExpiryDateComponent: InputDatepickerRendererComponent;
  constructor(
    private offcanvas: NgbOffcanvas,
    public toaster: ToastrService,
    public renderer: Renderer2,
  ) {
    super(renderer);
   
  }

  ngOnInit(): void {
    this.amlDetailsModel = this.data?.amlDetailsModel || {};
    this.setDefaultValue()
  }
  setDefaultValue() {
    this.amlDetailsModel.pep ??= this.pep.No;
    this.amlDetailsModel.dualNationality ??= this.dualNationality.No;
    this.amlDetailsModel.residentialStatus ??= this.residentialStatus.Resident;
    this.amlDetailsModel.isSave =this.data?.amlDetailsModel?.isSave;
  }
  Save() {
    if (this.AMLDetailsForm?.valid && this.amlDetailsModel?.idExpiryDate && this.amlDetailsModel?.idIssuedDate) {
      this.amlDetailsModel.isSave = true;
      this.offcanvas?.dismiss(this.amlDetailsModel);
    } 
  }
  Close() {
    this.amlDetailsModel = {};
    this.setDefaultValue()
    if (this.data?.amlDetailsModel && this.amlDetailsModel.isSave)
      this.amlDetailsModel = this.data?.amlDetailsModel || {};
    this.offcanvas?.dismiss(this.amlDetailsModel);
  }
  Clear() {
    this.amlDetailsModel = {};
    this.setDefaultValue();
    this.idIssuedDateComponent?.getupdateCurrentDate();
    this.idExpiryDateComponent?.getupdateCurrentDate();
  }

  // ***********Static Dropdown**********
  genderDropdown = [
    { id: 'Male', name: 'Male' },
    { id: 'Female', name: 'Female' },
    { id: 'Other', name: 'Other' }
  ];

  OccupationDropdown = [
    { id: 'Accounting', name: 'Accounting' },
    { id: 'Advocacy Organizations', name: 'Advocacy Organizations' },
    { id: 'Air Couriers and Cargo Services', name: 'Air Couriers and Cargo Services' },
    { id: 'Advertising, Marketing and PR', name: 'Advertising, Marketing and PR' },
    { id: 'Banking/Financial Institutions', name: 'Banking/Financial Institutions' },
    { id: 'Business Services Other', name: 'Business Services Other' },
    { id: 'Charitable Organizations and Foundations', name: 'Charitable Organizations and Foundations' },
    { id: 'Consulting /Freelancer', name: 'Consulting /Freelancer' },
    { id: 'Data Analytics, Management, and Internet', name: 'Data Analytics, Management, and Internet' },
    { id: 'Defense', name: 'Defense' },
    { id: 'Education', name: 'Education' },
    { id: 'Facilities Management and Maintenance', name: 'Facilities Management and Maintenance' },
    { id: 'Government Service', name: 'Government Service' },
    { id: 'HR and Recruiting Services', name: 'HR and Recruiting Services' },
    { id: 'HealthCare', name: 'HealthCare' },
    { id: 'IT and Network Services and Support', name: 'IT and Network Services and Support' },
    { id: 'Jewellery Trading', name: 'Jewellery Trading' },
    { id: 'Outside UAE', name: 'Outside UAE' },
    { id: 'Sales & Services', name: 'Sales & Services' },
    { id: 'Others', name: 'Others' },
    { id: 'Owner/Partner/Director', name: 'Owner/Partner/Director' },
  ];

  sourceOfIncomeDropdown = [
    { id: 'Salary', name: 'Salary' },
    { id: 'Personal Savings', name: 'Personal Savings' },
    { id: 'Bank - Cash withdrawal Slip', name: 'Bank - Cash withdrawal Slip' },
    { id: 'Funds from Dividend Payouts', name: 'Funds from Dividend Payouts' },
    { id: 'End of Services Funds', name: 'End of Services Funds' },
    { id: 'Business Proceeds', name: 'Business Proceeds' },
    { id: 'Other sources', name: 'Other sources' },
    { id: 'Gift', name: 'Gift' },
    { id: 'Loan from Friends and Family', name: 'Loan from Friends and Family' },
    { id: 'Loans from Bank', name: 'Loans from Bank' },
    { id: 'Loan from Financial Institutions', name: 'Loan from Financial Institutions' },
    { id: 'Lottery/Raffles', name: 'Lottery/Raffles' },
  ];

  purposeDropdown = [
    { id: 'Personal Use', name: 'Personal Use' },
    { id: 'Gift', name: 'Gift' },
    { id: 'Investment', name: 'Investment' },
    { id: 'Others', name: 'Others' },
  ];

  paymentModeDropdown = [
    { id: 'Cash', name: 'Cash' },
    { id: 'Debit/Credit Card', name: 'Debit/Credit Card' },
    { id: 'Bank transfer- Inside UAE', name: 'Bank transfer- Inside UAE' },
    { id: 'Bank transfer- Outside UAE', name: 'Bank transfer- Outside UAE' },
    { id: 'Partial Cash/Card/Online trs', name: 'Partial Cash/Card/Online trs' },
    { id: 'Digital Currency', name: 'Digital Currency' },
    { id: 'Old Gold Exchange', name: 'Old Gold Exchange' },
    { id: 'Payment from HRC', name: 'Payment from HRC' },
    { id: 'Others', name: 'Others' },
  ];

  idIssuedByDropdown = [
    { id: 'Passport', name: 'Passport' },
    { id: 'EID', name: 'EID' },
    { id: 'GCC ID', name: 'GCC ID' },
    { id: 'Govt Approved ID', name: 'Govt Approved ID' },
  ];

  modeofApproachDropdown = [
    { id: 'Walk-In Customer', name: 'Walk-In Customer' },
    { id: 'Non Face to Face', name: 'Non Face to Face' },
    { id: 'Online/Social Media Portal', name: 'Online/Social Media Portal' },
    { id: 'Thirdparty Referral', name: 'Thirdparty Referral' },
  ];

  productTypeDropdown = [
    { id: '18/21/22K Gold Jewellery', name: '18/21/22K Gold Jewellery' },
    { id: '22/24K Gold Coin', name: '22/24K Gold Coin' },
    { id: '24K Gold Bar', name: '24K Gold Bar' },
    { id: 'Silver Bar/Jewellery', name: 'Silver Bar/Jewellery' },
    { id: 'Scrap/Old Gold', name: 'Scrap/Old Gold' },
    { id: 'Diamond Studded Jewellery', name: 'Diamond Studded Jewellery' },
    { id: 'Uncut Diamond', name: 'Uncut Diamond' },
    { id: 'Polki Diamond', name: 'Polki Diamond' },
    { id: 'Other Precious Stones', name: 'Other Precious Stones' },
    { id: 'Platinum Product', name: 'Platinum Product' },
    { id: 'Dore Bar/Mined Gold', name: 'Dore Bar/Mined Gold' },
    { id: 'Buying/Selling/Leasing Property', name: 'Buying/Selling/Leasing Property' },
    { id: 'Real Estate', name: '1Real Estate' },
  ]
}
export enum PEP {
  Yes = 'Yes',
  No = 'No'
}
export enum DualNationality {
  Yes = 'Yes',
  No = 'No'
}
export enum ResidentialStatus {
  Resident = 'Resident',
  NonResident = 'Non-Resident'
}